<div class="dropzone">
  <input type="file" (change)="uploadTemplate($event)" accept=".doc, .docx" />
  <div class="dropzone-visual-content">
    <div class="icon" [ngClass]="isDragOver ? 'hide-icon' : 'blue-icon'">
      <fa-icon [icon]="faCloudArrowUp" size="xl"></fa-icon>
    </div>
    @if (!isDragOver) {
      <p class="normal-text">
        {{ 'dragAndDropTemplate' | i18nextCap }}
      </p>
    }
    @if (isDragOver) {
      <p class="normal-text">
        {{ 'releaseToUploadFile' | i18nextCap }}
      </p>
    }
  </div>
</div>
